import type { SVGProps } from "react";

const CombustionIcon = ({
  width = 24,
  height = 24,
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill="#000"
      d="M13.367 22.71c3.256-.653 7.466-2.995 7.466-9.053 0-5.512-4.034-9.182-6.936-10.869-.643-.374-1.397.118-1.397.863v1.905c0 1.502-.632 4.243-2.386 5.383-.896.583-1.863-.289-1.972-1.352l-.09-.872C7.948 7.7 6.915 7.085 6.104 7.703c-1.457 1.111-2.979 3.057-2.979 5.955 0 7.407 5.51 9.259 8.264 9.259.16 0 .329-.005.504-.015.464-.059 0 .103 1.474-.192Z"
    />
    <path
      fill="#FFFF"
      d="M8.333 19.213c0 2.729 2.2 3.573 3.56 3.689.464-.059 0 .103 1.474-.192 1.082-.383 2.258-1.364 2.258-3.497 0-1.352-.853-2.186-1.52-2.576-.205-.12-.442.03-.46.267-.059.747-.777 1.343-1.266.775-.433-.503-.614-1.237-.614-1.707v-.614c0-.37-.373-.615-.691-.426-1.183.702-2.74 2.146-2.74 4.28Z"
    />
  </svg>
);
export default CombustionIcon;
